// extracted by mini-css-extract-plugin
export default {"img":"UserMenu_img__I2AWQ","Menu":"UserMenu_Menu__qUr8d","menuButton":"UserMenu_menuButton__JtRxw"};